import {
    UPDATE_BUILDING_TAB,
    UPDATE_BUILDING_INFO,
    UPDATE_BUILDING_HOUSE_INFO,
    SET_LISTING_DETAIL,
    SET_WHITE_TEAM
} from '../mutation-types';
export default {
    namespaced: true,
    state: () => ({
        curBuildingInfo: {},
        curBuildingHouseInfo: {},
        activeBuildingTab: 'sales',
        curListingDetail: {}, // normal 页面要用到
        whiteTeam: false // building 白名单
    }),
    getters: {
        isNormalPage(state) {
            // 判断当前显示的是否为normal页， 即没有三方building信息
            return JSON.stringify(state.curBuildingInfo) == '{}';
        },
        listingDetailInfo(state) {
            return state.curListingDetail || {};
        },
        buildingInfo(state) {
            return state.curBuildingInfo || {};
        },
        buildingHouseInfo(state) {
            return state.curBuildingHouseInfo || {};
        },
        basic(state, getters) {
            if (!getters.isNormalPage) {
                let { location, label, buildingName } =
                    state.curBuildingInfo || {};
                if (!location) {
                    return {};
                }
                let [lat, lng] = location.split(',');
                return {
                    location: {
                        lat: +lat,
                        lng: +lng
                    },
                    address: label,
                    name: buildingName || label
                };
            }
            let { address, latitude, longitude } = state.curListingDetail || {};
            if (isNaN(latitude) || isNaN(longitude)) {
                return {};
            }
            return {
                location: {
                    lat: +latitude,
                    lng: +longitude
                },
                address: address,
                name: address
            };
        },
        subwayList(state) {
            return state.curBuildingInfo?.nearestSubway || [];
        }
    },
    mutations: {
        [UPDATE_BUILDING_TAB](state, payload) {
            state.activeBuildingTab = payload || 'sales';
        },
        [UPDATE_BUILDING_INFO](state, payload) {
            state.curBuildingInfo = payload || {};
        },
        [UPDATE_BUILDING_HOUSE_INFO](state, payload) {
            state.curBuildingHouseInfo = payload || {};
        },
        [SET_LISTING_DETAIL](state, payload) {
            state.curListingDetail = payload || {};
        },
        [SET_WHITE_TEAM](state, payload) {
            state.whiteTeam = payload || false;
        }
    }
};
